import { inject } from 'inversify';

import { service } from '@/decorators/service';
import { SignalrListener } from '@/decorators/signalr';
import { FilterStore } from '@/stores/FilterStore';
import { IFilter } from '~/IFilter';

@SignalrListener
@service(FilterManager)
export class FilterManager {
  @inject(FilterStore) protected filterStore: FilterStore;

  get getFilters() {
    return this.filterStore.all();
  }

  get getDefaultFilter() {
    const filters = this.getFilters;
    return filters.find((filter) => filter.default === true) || null;
  }

  get getActiveFilter() {
    const filters = this.getFilters;
    return filters.find((filter) => filter.active === true) || null;
  }

  updateFilters(filters: IFilter[]) {
    this.filterStore.update(...filters);
  }

  deleteFilter(filterId: string) {
    this.filterStore.remove(filterId);
  }

  updateFilter(filter: IFilter) {
    this.filterStore.update(filter);
  }

  setActiveFilter(filterId: string) {
    const filters = this.getFilters;
    const updatedFilters = filters.map((filter) => ({
      ...filter,
      active: filter.id === filterId,
    }));

    this.updateFilters(updatedFilters);
  }

  setDefaultFilter(filterId: string) {
    const filter = this.findFilter(filterId);
    if (!filter?.id) return;
    this.updateFilter({ ...filter, default: true });
  }

  findFilter(id: string) {
    return this.filterStore.find(id);
  }

  findFilterByName(name: string) {
    return this.getFilters.find((filter) => filter.name.toLowerCase() === name);
  }
}
